import {
  PRODUCT_ARTICLE_IMAGE_HEIGHT,
  PRODUCT_ARTICLE_IMAGE_WIDTH,
} from "./BookListingItem";
import { LiteraryWorkItem } from "../types";
import { getPageLink } from "@/navigation/selectors";
import classNames from "classnames";
import NextLink from "next/link";
import Image from "next/image";
import {
  BookStencil,
  Canvas,
  Link,
  Tag,
  Typography,
} from "@cappelendamm/design-system/react";
import { ListingItemProps } from "./types";

export function LiteraryWorkListingItem({
  item,
  config,
}: ListingItemProps<LiteraryWorkItem>) {
  const { objectID: sku, imageUrl, name, slug, subtitle } = item;
  const href = getPageLink({ pageType: "literaryWork", params: slug });
  return (
    <article
      className={classNames(
        "row-span-[var(--list-row-count)] grid min-w-0 grid-rows-subgrid gap-1 p-0",
        "active:rounded active:outline-3 active:outline-offset-4 active:outline-[var(--cvr-canvas-background)]",
      )}
    >
      <NextLink
        href={href}
        aria-labelledby={`item-${sku}`}
        className={classNames(
          "group relative grid min-w-0 grid-rows-subgrid no-underline",
          config?.fields?.series
            ? "row-span-[calc(var(--list-row-count)-1)]"
            : "row-span-full",
        )}
      >
        <div className="row-[1/-2] grid items-start gap-4">
          <Canvas className="px-2 py-2 md:px-6 md:py-2">
            <div className="absolute top-0 left-0 flex flex-col gap-2 [&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:rounded-tr-md">
              <Tag variant={"informational"}>Læreverk</Tag>
            </div>
            {imageUrl ? (
              <Image
                src={imageUrl}
                className={classNames(
                  "transition-transform",
                  "sm:group-hover:scale-102",
                )}
                alt={`Omslag fra verk "${name}"`}
                width={PRODUCT_ARTICLE_IMAGE_WIDTH * 3}
                height={PRODUCT_ARTICLE_IMAGE_HEIGHT}
                quality={100}
              />
            ) : (
              <div className="flex gap-2">
                <BookStencil
                  style={
                    {
                      "--book-width": `${PRODUCT_ARTICLE_IMAGE_WIDTH}px`,
                    } as React.CSSProperties
                  }
                />
                <BookStencil
                  style={
                    {
                      "--book-width": `${PRODUCT_ARTICLE_IMAGE_WIDTH}px`,
                    } as React.CSSProperties
                  }
                />
              </div>
            )}
          </Canvas>
          <Typography
            id={`item-${sku}`}
            as="h3"
            variant="title-md"
            className={classNames("truncate", {
              "sm:group-hover:underline": href,
            })}
          >
            {name}
          </Typography>
          <Typography
            as="p"
            variant="body-base"
            className="order-4 mt-0 block truncate"
            muted
          >
            {subtitle}
          </Typography>
        </div>
        <Link
          as="span"
          variant="inline"
          className="order-6 text-sm sm:group-hover:underline"
        >
          Se komponenter
        </Link>
      </NextLink>
    </article>
  );
}
